import React from "react";
import { useSelectDocumentsContext } from "../context";
import { Props } from "./types";
import { DirectoryStructure } from "./directoryStructure";
import styles from "./styles.scss";

function SideBar({}: Props) {
  const {
    rootFolder,
    currentFolderId,
    currentFolderPath: path,
  } = useSelectDocumentsContext();

  return (
    <div className={styles.navbar}>
      <div className={styles.directoryStructure}>
        <DirectoryStructure
          folder={rootFolder}
          selectedFolderId={currentFolderId}
          selectedFolderPath={path}
          isRoot={true}
        />
      </div>
    </div>
  );
}

export { SideBar };
